function supports(restrictedNodes, nNodes) {

    var restrictedDisplacementVector = []

    //criando um vetor zerado para restrição de movimento dos nós
    for(let i = 0; i < 3*nNodes; i++){
        restrictedDisplacementVector[i] = 0
    }

    //atribuindo 1 aos deslocamentos restritos
    for(let i = 0; i < nNodes; i++){
        if(restrictedNodes[i] === '1'){
            restrictedDisplacementVector[3*i+1]=1
            console.log("passei aqui")
        }
        else {
            for(let j = 0; j < restrictedNodes[i]; j++){
                restrictedDisplacementVector[3*i+j] = 1
            }
        }
    }

    return restrictedDisplacementVector;
}

export default supports